<template>
  <b-modal
    ref="modal"
    :visible="true"
    static
    lazy
    centered
    no-fade
    :title="title"
    hide-footer
    @hidden="onHidden"
  >
    <form @submit.prevent="submit" novalidate>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="gf-title">Название <span class="text-danger">*</span></label>
        <input id="gf-title" v-model="form.title" type="text" class="form-control form-control-sm" :disabled="busy" maxlength="255">
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted d-block">Цвет</label>
        <div class="gfm__swatches">
          <button
            v-for="c in palette"
            :key="c"
            type="button"
            class="gfm__swatch"
            :class="{ 'gfm__swatch--on': form.color_code === c }"
            :style="{ background: c }"
            :aria-label="'Цвет ' + c"
            :aria-pressed="String(form.color_code === c)"
            @click="form.color_code = c"
          ><svg v-if="form.color_code === c" class="gfm__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5 6.5 12 13 4.5" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
          <button
            v-if="customColor"
            type="button"
            class="gfm__swatch gfm__swatch--custom"
            :class="{ 'gfm__swatch--on': form.color_code === customColor }"
            :style="{ background: customColor }"
            :aria-label="'Текущий цвет ' + customColor"
            :aria-pressed="String(form.color_code === customColor)"
            @click="form.color_code = customColor"
          ><svg v-if="form.color_code === customColor" class="gfm__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5 6.5 12 13 4.5" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger py-2 mb-3" role="alert">{{ error }}</div>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm gfm__cancel" :disabled="busy" @click="hideModal">Отмена</button>
        <button type="submit" class="btn btn-success btn-sm gfm__submit" :disabled="busy">Сохранить</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import * as api from '@/components/management/dispatcher/api';
import { GROUP_PALETTE, groupColor, UNGROUPED_COLOR } from '@/components/management/dispatcher/objectState';
import { notifySuccess, notifyError } from '@/components/management/dispatcher/notify';
import modalCloseMixin from './modalCloseMixin';

export default {
  name: 'GroupFormModal',
  mixins: [modalCloseMixin],
  props: { group: { type: Object, default: null } },
  data() {
    const existing = this.group ? groupColor(this.group) : null;
    const known = existing && existing !== UNGROUPED_COLOR ? existing : null;
    return {
      palette: GROUP_PALETTE,
      customColor: known && !GROUP_PALETTE.includes(known) ? known : null,
      form: { title: this.group ? (this.group.title || '') : '', color_code: known || GROUP_PALETTE[0] },
      error: '',
      busy: false,
    };
  },
  computed: {
    title() { return this.group ? 'Изменение группы' : 'Новая группа точек'; },
  },
  methods: {
    async submit() {
      if (this.busy) return;
      const title = this.form.title.trim();
      if (!title) { this.error = 'Укажите название группы.'; return; }
      this.error = '';
      this.busy = true;
      try {
        const payload = { title, color_code: this.form.color_code };
        const saved = this.group ? await api.updateGroup({ id: this.group.id, ...payload }) : await api.createGroup(payload);
        notifySuccess(this, 'Группа сохранена');
        this.$emit('saved', saved);
        this.hideModal();
      } catch (e) {
        notifyError(this, e);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.gfm__swatches { display: flex; gap: 8px; flex-wrap: wrap; }
// The theme's `button { outline: none !important }` kills outlines, so the selected ring is a box-shadow.
.gfm__swatch {
  width: 34px; height: 34px; border-radius: 9px; border: 1px solid rgba(0, 0, 0, .08); cursor: pointer; padding: 0;
  display: inline-flex; align-items: center; justify-content: center;
  &--on { box-shadow: 0 0 0 2px #fff, 0 0 0 4px #171a19; }
  &:focus-visible { box-shadow: 0 0 0 2px #fff, 0 0 0 4px #17876f; }
}
.gfm__check { width: 18px; height: 18px; filter: drop-shadow(0 1px 1px rgba(0, 0, 0, .35)); }
</style>
